import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { LicenseDialogComponent } from './license-dialog/license-dialog.component';
import { MainLoaderService } from 'src/app/services/main-loader.service';
import { ApiPagination } from 'src/app/models/api/api-pagination.model';
import { LicenseService } from 'src/app/services/license.service';
import { License } from 'src/app/models/license/license.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { Component, inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-licenses',
  templateUrl: './licenses.component.html',
  styleUrl: './licenses.component.scss',
})
export class LicensesComponent implements OnInit {
  private _mainLoaderService: MainLoaderService = inject(MainLoaderService);
  private _licenseService: LicenseService = inject(LicenseService);
  private _baseComponentService = inject(BaseComponentService);
  public error?: ApiError = undefined;
  public pagination?: ApiPagination;
  public loading: boolean = true;
  public licenses: License[] = [];

  ngOnInit(): void {
    this.getData();
  }

  public onPage(event: number): void {
    if (this.pagination) {
      this.pagination.page = event;
      this.getData();
    }
  }

  private getData(): void {
    this.loading = true;
    this.error = undefined;
    this._licenseService
      .getLicensesListing({
        page: this.pagination?.page || 0,
        limit: this.pagination?.limit || 25,
      })
      .subscribe({
        next: (data: any) => {
          this.pagination = new ApiPagination(data.pagination);
          this.licenses = data?.data?.map((json: any) => new License(json));
        },
        error: (error) => {
          this.error = new ApiError(error);
          console.error('License Listing Error:', error.message);
        },
      })
      .add(() => (this.loading = false));
  }

  async showLicenseDialog(licenseId?: string) {
    const dialogSize = '650px';
    const dialogRef = this._baseComponentService.dialog.open(
      LicenseDialogComponent,
      {
        maxWidth: dialogSize,
        minWidth: dialogSize,
        data: { licenseId },
        autoFocus: false,
        restoreFocus: false,
      }
    );
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult === true) {
        this.getData();
      }
    });
  }

  async showDeleteDialog(licenseId?: string) {
    this._baseComponentService
      .confirmDeletion({
        message: 'Confermi di voler eliminare questa licenza?',
        details: '(Non sarà possibile annullare questa operazione)',
        destructive: true,
      })
      .subscribe((dialogResult) => {
        if (dialogResult === true) {
          this._licenseService.deleteLicense(licenseId).subscribe({
            next: (_) => this.getData(),
            error: (error: unknown) => {
              console.error('deleteLicense - ERROR:', error);
              this._baseComponentService.showErrorDialog({
                error: new ApiError(error),
              });
            },
          });
        }
      });
  }

  fakeFunc(): void {}

  protected forceSync(licenseId?: string) {
    if (!licenseId) return;
    this._baseComponentService
      .confirmDeletion({
        message:
          "Confermi di voler forzare la sincronizzazione dell'assegnazione automatica di questa licenza in base alle regole impostate?",
        details:
          'ATTENZIONE: il tempo di risposta potrebbe variare molto in base alle regole impostate. Si prega di attendere...',
        trueBtn: 'Sì, sincronizza',
        falseBtn: 'No, annulla',
        destructive: false,
        size: '500px',
      })
      .subscribe((response) => {
        if (response === true) {
          this._mainLoaderService.setMessage(
            'Aggiornamento assegnazioni automatiche in corso, attendere...',
            true
          );
          this._licenseService
            .syncLicenseAssignments(licenseId)
            .subscribe({
              next: (res) => {
                const license = new License(res.data);
                const index = this.licenses.findIndex(
                  (l) => l.id === license.id
                );
                if (index >= 0) this.licenses[index] = license;
              },
              error: (error) => {
                console.error('ERROR:', error);
                this._baseComponentService.showErrorDialog({
                  error: new ApiError(error),
                });
              },
            })
            .add(() => this._mainLoaderService.setShow(false));
        }
      });
  }
}
